const transform = (treatments, generateUri, i18n) =>
  treatments.map((treatment) => {
    const id = treatment.id;
    const normalisedName = treatment.normalisedName;
    const title = treatment.name;
    const description = i18n(`page.treatment.${id}.description`);
    const image = treatment.image || {};
    const imageUri = Object.values(image.uris || {})[0];
    const uri = generateUri('treatment', { normalisedName });

    return {
      title,
      description,
      uri,
      imageUri,
    };
  });

export default transform;
